import VoltageIcon from './component'

export default VoltageIcon
